import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag, DollarSign } from 'lucide-react';
import './ProductCard.css';

const ProductCard = ({ product }) => {
  if (!product) return null;

  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format(price);
  };

  return (
    <Link to={`/products/${product.id}`} className="product-card">
      {product.image_url && (
        <div className="product-card-image">
          <img src={product.image_url} alt={product.name} />
          {product.status === 'out_of_stock' && (
            <div className="product-card-badge product-card-badge-out-of-stock">
              Out of Stock
            </div>
          )}
        </div>
      )}
      
      <div className="product-card-content">
        <div className="product-card-header">
          <h3 className="product-card-title">{product.name}</h3>
          {product.category && (
            <span className="product-card-category">{product.category}</span>
          )}
        </div>
        
        {product.description && (
          <p className="product-card-description">
            {product.description.length > 100 
              ? `${product.description.substring(0, 100)}...` 
              : product.description}
          </p>
        )}
        
        <div className="product-card-footer">
          <div className="product-card-price">
            <DollarSign size={18} />
            <span>{formatPrice(product.price)}</span>
          </div>
          <button className="product-card-button">
            <ShoppingBag size={18} />
            View Details
          </button>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;


